import {configureStore} from "@reduxjs/toolkit";
import servicesSlice from "../features/services/redux/services.slice";
import workersSlice from "../features/workers/redux/workers.slice";
import appSlice from "./app.slice";
import authSlice from "../auth/redux/auth.slice";
import adminsSlice from "../features/admins/redux/admins.slice";
import clientsSlice from "../features/clients/redux/clients.slice";
import ordersSlice from "../features/orders/redux/orders.slice";
import availabilitiesSlice from "../features/availibilities/redux/availabilities.slice";
import suggestedAvailabilitiesSlice from "../orderEngine/redux/suggestedAvailibilities.slice";

export const store = configureStore({
    reducer: {
        auth: authSlice,
        app: appSlice,
        admins: adminsSlice,
        clients: clientsSlice,
        services: servicesSlice.reducer,
        workers: workersSlice,
        availabilities: availabilitiesSlice,
        orders: ordersSlice,
        suggestedAvailabilities: suggestedAvailabilitiesSlice
    }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
